(function (angular) {
    angular.module('bizPartEngage').service('core.engage.service', engageService);

    engageService.$inject = ["$http", "$q", "$state"];

    function engageService($http, $q, $state) {
    	var apiPath = siteRootPath + "api/engage/";
    	var settingsPromise;
    	var engageJourneyPromise;

    	return {
    		ClearPromiseCache: ClearPromiseCache,
    		GetSettings: GetSettings,
			SaveSettings: SaveSettings,
    		GetSuggestions: GetSuggestions,
    		GetEngageJourneys: GetEngageJourneys,
    		GetEngageJourneysByFavoriteTags: GetEngageJourneysByFavoriteTags,
            GetEngageJourneysForUser: GetEngageJourneysForUser,
            HandleEngageObjectCancelled: HandleEngageObjectCancelled,
            RedirectToEngageObject: RedirectToEngageObject,
            IsEngageObject: IsEngageObject,
            GetEngageObjectsByObjectIdAndType: GetEngageObjectsByObjectIdAndType,
            GetEngageObjectTypeId: GetEngageObjectTypeId,
            GetEngageObjectTypeById: GetEngageObjectTypeById            
        };

        function GetEngageObjectTypeId(objectTypeName) {
            var ot = objectTypeName.toLowerCase();
            switch (ot) {
                case 'html5':
                    return 1;                    
                case 'mediabankfile':
                    return 3;                    
                case 'blog':
                    return 2;                    
                case 'scorm':
                    return 4;
                case 'speedquiz':
                    return 5;
                case 'certification':
                    return 6;
                case 'mission':
                    return 7;
                default:
                    return 0;
            }                   
        }

        function GetEngageObjectTypeById(objectTypeId) {
            switch (objectTypeId) {
                case 1:
                    return 'html5';
                case 3:
                    return 'mediabankfile';
                case 2:
                    return 'blog';
                case 4:
                    return 'scorm';
                case 5:
                    return 'speedquiz';
                case 6:
                    return 'certification';
                case 7:
                    return 'mission';
                default:
                    return 'None';
            }                   
        }

        function IsEngageObject(objectType) {
            var engageObjectTypes = ['html5', 'mediabankfile', 'blog', 'scorm'];            
            return engageObjectTypes.indexOf(objectType.toLowerCase()) >= 0;            
        }

        function RedirectToEngageObject(objectType, objectId) {
            var ot = objectType.toLowerCase();
            switch (ot) {
                case 'html5':
                    $state.go("base.modules.html5education", { id: objectId });
                    break;
                case 'mediabankfile':
                    $state.go("base.modules.mediafile", { id: objectId });
                    break;
                case 'blog':
                    $state.go("base.modules.blogtitle", { title: objectId });
                    break;
                case 'scorm':
                    location.href = siteRootPath + "SCORM/" + objectId;
                    break;
            }                   
        }        

    	function ClearPromiseCache() {
    		settingsPromise = null;
    		engageJourneyPromise = null;
    	}

    	function SaveSettings(settings) {
    		return $http.post(apiPath + 'SaveEngageSettingsForUser', settings);
    	}

    	function GetSettings(force) {
    		if (!force && settingsPromise) return settingsPromise;

    		settingsPromise = $http.get(apiPath + 'GetEngageSettingsForUser');
    		return settingsPromise;
    	}

    	function GetEngageJourneysForUser(force) {
    		// if (!force && engageJourneyPromise) return engageJourneyPromise;

    		var deferrer = $q.defer();
    		engageJourneyPromise = deferrer.promise;

    		$q.all([GetEngageJourneys(false),
					GetEngageJourneysByFavoriteTags(false)])
				.then(function (responses) {
    				deferrer.resolve({
    					General: responses[0].data,
    					Custom: responses[1].data
    				});
    			});

    		return engageJourneyPromise;
    	}

    	function GetEngageJourneysByFavoriteTags(deepload) {
    		return $http.get(apiPath + "GetEngageJourneysByFavoriteTags", {
    			params: {
    				deepload: deepload
    			}
    		});
    	}

    	function GetEngageJourneys(deepload) {
    		return $http.get(apiPath + "GetEngageJourneys", {
    			params: {
					deepload: deepload
    			}
    		});
    	}

        function GetSuggestions(max, page) {
            if (!page || page < 0) page = 1;
    		return $http.get(apiPath + "GetSuggestions", {
        		params: {
        			max: max,
        			page: page
        		}
        	});
        }

        function HandleEngageObjectCancelled(objectId, objectType) {            

            var params = {
                objectId: objectId,
                objectType: objectType                
            };

            $http.post(apiPath + 'HandleEngageObjectCancelled', {}, {
                params: params,
                headers: {
                    IgnoreLoader: true
                }
            });
        }

        function GetEngageObjectsByObjectIdAndType(objects) {            

            return $http.post(apiPath + 'GetEngageObjectsByObjectIdAndType', objects, {                
                headers: {
                    IgnoreLoader: true
                }
            });
        }
    }
})(window.angular);
